/**
 * @module Experience/Shop/Cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const CART_MODULE_COMPONENTS = {
  CART_MODULE: 'CartModule',
  CART_LANDING_COMPONENT: 'CartLandingComponent',
  ACCOUNT_HOLDER_INFO_COMPONENT: 'AccountHolderInfoComponent',
  ACCOUNT_SETUP_LANDING_COMPONENT: 'AccountSetupLandingComponent',
  BILLING_ADDRESS_COMPONENT: 'BillingAddressComponent',
  ACCOUNT_SETUP_SERVICE: 'AccountSetupService',
  ADD_LINE_COMPONENT: 'AddLineComponent',
  PRICING_PANEL_COMPONENT: 'PricingPanelComponent',
  CART_REVIEW_SERVICE: 'CartReviewService',
  LINE_SETUP_SERVICE: 'LineSetupService',
  RUN_CREDIT_MODAL_COMPONENT: 'RunCreditModalComponent',
};

export const BACK_NAVIGATION_CONSTANTS = {
  ACCOUNT_SETUP: 'accountSetUp',
  LINE_SETUP: 'lineSetUp',
  SHIPPING: 'shipping',
  CARD_ADDRESS: 'cardAddressDetails'
};
